import { render } from "./InlineActionButton.vue?vue&type=template&id=6526a07f&scoped=true"
import script from "./InlineActionButton.vue?vue&type=script&lang=js"
export * from "./InlineActionButton.vue?vue&type=script&lang=js"

import "./InlineActionButton.vue?vue&type=style&index=0&id=6526a07f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6526a07f"]])

export default __exports__